export const unitConverters = [
  {
    name: "تحويل وحدات الطول",
    link: "/ar/unit_converter/length/",
    description:
      "أداة سريعة ودقيقة لتحويل القيم بين وحدات الطول المختلفة. سواء كنت تتعامل مع المتر، السنتيمتر، الكيلومتر، أو القدم والبوصة، يمكن لهذا المحول مساعدتك في تحويل القيم بسهولة. مفيد للبنائين، المهندسين، والطلاب.",
    showMain: true,
  },
  {
    name: "تحويل وحدات الوزن",
    link: "/ar/unit_converter/weight/",
    description:
      "أداة بسيطة وفعالة لتحويل القيم بين مختلف وحدات الوزن الشائعة. يمكنك استخدامها لتحويل الجرام إلى كيلوجرام، والأوقية إلى رطل، والعكس صحيح. مثالية للاستخدام في الطبخ، الخبز، والمشاريع العلمية.",
    showMain: true,
  },
  {
    name: "تحويل وحدات الحرارة",
    link: "/ar/unit_converter/temperature/",
    description:
      "أداة سريعة وسهلة لتحويل درجات الحرارة بين مختلف المقاييس مثل السلسيوس، الفهرنهايت، والكلفن. سواء كنت تخطط لرحلة، تقوم بطبخة تتطلب درجة حرارة محددة، أو تحتاج إلى إجراء حسابات علمية، فإن هذا المحول سيكون مفيدًا لك.",
    showMain: true,
  },
  {
    name: "تحويل وحدات المساحة",
    link: "/ar/unit_converter/area/",
    description:
      "أداة عملية لتحويل القيم بين وحدات المساحة المختلفة مثل المتر المربع، السنتيمتر المربع، الكيلومتر المربع، والقدم المربع. سواء كنت تقوم بتصميم منزل، تحسب مساحة الأرض، أو تعمل على مشروع هندسي",
    showMain: true,
  },
  {
    name: "تحويل وحدات الحجم",
    link: "/ar/unit_converter/volume/",
    description:
      "أداة بسيطة وسريعة لتحويل القيم بين مختلف وحدات الحجم مثل اللتر، المليلتر، المتر المكعب، والقدم المكعب. سواء كنت تطبخ، تعمل في البناء، أو تدرس الفيزياء، فإن هذا المحول يمكن أن يكون مفيدًا جدًا في تحويل الوحدات بدقة وسرعة.",
    showMain: true,
  },
  {
    name: "تحويل وحدات الزمن",
    link: "/ar/unit_converter/time/",
    description:
      "أداة عملية لتحويل القيم بين وحدات الزمن المختلفة مثل الثواني، الدقائق، الساعات، الأيام، والسنوات. سواء كنت تخطط لرحلة، تحسب مدة مشروع، أو تدرس الفيزياء، فإن هذا المحول يمكن أن يساعدك في تحويل الوحدات الزمنية بسهولة ودقة.",
    showMain: true,
  },
  {
    name: "تحويل الارقام العربية إلى الإنجليزية",
    link: "/calculator/ar/arabic-to-english/",
    description: "أدخل الأرقام العربية ليتم تحويلها إلى أرقام إنجليزية.",
    showMain: true,
  },
  {
    name: "تحويل الارقام الانجليزيه إلى العربية",
    link: "/calculator/ar/english-to-arabic/",
    description: "أدخل الأرقام الانجليزية ليتم تحويلها إلى أرقام عربية.",
  },
  {
    name: "تحويل الارقام الى احرف وكلمات",
    link: "/calculator/ar/numbers-to-words/",
    description: "قم بتحويل الأرقام إلى كلمات باللغة العربية والإنجليزية.",
  },
  {
    name: "تحويل الرابط الى باركود - إنشاء باركود QR",
    link: "/calculator/ar/qr-code/",
    description: "حوّل الروابط إلى رموز QR بسهولة وسرعة.",
  },
  // clothing-size-converter
  {
    name: "تحويل مقاسات الملابس",
    link: "/calculator/ar/clothing-size-converter/",
    description:
      "أداة لتحويل مقاسات الملابس بين الأنظمة المختلفة مثل US، UK، EU، واليابانية. سواء كنت تتسوق عبر الإنترنت أو تحتاج إلى معرفة مقاسك في نظام مختلف، فإن هذا المحول سيساعدك في العثور على المقاس المناسب بسهولة.",
  },
];
export default unitConverters;